/**
 * 业务权限接口
 **/
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessPermissionService {

  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService,
  ) {
  }

 //#region 业务权限接口
  /**
  * 角色业务权限查询
  * @param param
  * @returns {Observable<any>}
  */
 roleQueryByFk(param) {
  const url = this.prefix + 'roleBusiness/queryByFk';
  return this.http.Post(url, param);
}

/**
  * 角色业务权限保存
  * @param param
  * @returns {Observable<any>}
  */
 roleSaveOrDelete(param) {
  const url = this.prefix + 'roleBusiness/saveOrDelete';
  return this.http.Post(url, param);
}

/**
  * 岗位业务权限查询
  * @param param
  * @returns {Observable<any>}
  */
 positionQueryByFk(param) {
  const url = this.prefix + 'positionBusiness/queryByFk';
  return this.http.Post(url, param);
}

/**
  * 岗位业务权限保存
  * @param param
  * @returns {Observable<any>}
  */
 positionSaveOrDelete(param) {
  const url = this.prefix + 'positionBusiness/saveOrDelete';
  return this.http.Post(url, param);
}
 //#endregion
}
